import { service } from '@/ajax/request'
import { AxiosPromise } from 'axios'

// 实时统计
export const realTime = (): AxiosPromise => (
  service({
    url: `/report/realTime`,
    method: 'GET',
    type: 'form'
  })
)

// 支付概述
export const paySummary = (): AxiosPromise => (
  service({
    url: `/report/paySummary`,
    method: 'GET',
    type: 'form'
  })
)

//账号概述
export const accountInfo = (): AxiosPromise => (
  service({
    url: `/report/getAccountInfo`,
    method: 'GET',
    type: 'form'
  })
)

// 待办事项
export const backLogToDo = (): AxiosPromise => (
  service({
    url: `/report/backLogToDo`,
    method: 'GET',
    type: 'form'
  })
)

// 获取订单交易总额
export const transactionOrder = (): AxiosPromise => (
    service({
        url: `/report/transaction/order`,
        method: 'GET',
        type: 'form'
    })
)

// 获取费用交易总额
export const transactionCost = (): AxiosPromise => (
    service({
        url: `/report/transaction/cost`,
        method: 'GET',
        type: 'form'
    })
)

// 企业/个人 入驻
export const memberEnter = (): AxiosPromise => (
    service({
        url: `/report/member/enter`,
        method: 'GET',
        type: 'form'
    })
)

// 用户数量
export const memberCount = (): AxiosPromise => (
    service({
        url: `/report/member/count`,
        method: 'GET',
        type: 'form'
    })
)

// 客户返佣金额
export const customCount = (): AxiosPromise => (
    service({
        url: `/report/custom/count`,
        method: 'GET',
        type: 'form'
    })
)

